import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components';

var marked = require('marked');
marked.setOptions({
  gfm: true,
  tables: true,
  breaks: true,
  sanitize: true
});

import Card from '../Shared/Card';

const News_Item = (props) => (
      <NewsCard type={props.news.type && props.news.type[0]} >
        <NewsDate>{new Date(props.news.date).toLocaleDateString()}</NewsDate>
        <NewsTitle>{props.news.title}</NewsTitle>
        {props.news.description &&
          <NewsDetails
            dangerouslySetInnerHTML={{__html: marked(props.news.description.description, {sanitize: true})}}>
          </NewsDetails>
        }
      </NewsCard>
);

export default News_Item;

const NewsCard = Card.extend`
  margin: 0px 0px 10px;
  &:last-of-type {
    margin-bottom: 20px;
  }
  border-left: 5px solid ${props =>
    (props.type == 'Award' && 'gold')
    || (props.type == 'Meeting' && 'rebeccapurple')
    || (props.type == 'Position' && 'tomato')
    || (props.type == 'Poster' && 'mediumseagreen')
    || (props.type == 'Presentation' && 'steelblue')
    || (props.type == 'Publication' && 'lightblue')
    || '#333'
  };
`;

const NewsTitle = styled.h2`
  font-weight: 300;
  line-height: 1.8rem;
  font-size: 1.5rem;
  margin: 0px 0px .5rem;
`

const NewsDate = styled.p`
  line-height: 1.5rem;
  font-size: 1rem;
  margin: 0px 0px .5rem;
  font-weight: 500;
  opacity: 0.8;
`;

const NewsDetails = styled.p`
  line-height: 1.5rem;
  font-size: 1.1rem;
  font-weight: 300;
  margin: 0px 0px 0;
  opacity: 0.8;
  & p:last-of-type {
    margin-bottom: 0;
  }
`;


// WEBPACK FOOTER //
// ./src/components/News_Item/index.js